import {
  APP_VERSION,
  ANDROID_APP_DISMISSED_VERSION_KEY,
} from "../Constants/androidApp";

export const getDismissedAndroidAppVersion = () =>
  localStorage.getItem(ANDROID_APP_DISMISSED_VERSION_KEY);

export const shouldShowAndroidUpdateBanner = () => {
  const dismissedVersion = getDismissedAndroidAppVersion();
  if (!dismissedVersion) return true;
  return dismissedVersion !== APP_VERSION;
};

export const dismissAndroidUpdateBanner = () => {
  localStorage.setItem(ANDROID_APP_DISMISSED_VERSION_KEY, APP_VERSION);
};
